import WarpEvent from "./WarpEvent";
export default class WarpEndEvent extends WarpEvent {
}
